import { CellContext } from '@tanstack/react-table'

import { DATE_FORMAT, formatDate } from 'utils/date'

type LastModifiedCellProps<
  T extends {
    updatedAt: Date
  },
> = CellContext<T, unknown> & { convertToUtc?: boolean; dateFormat?: string }

const LastModifiedCell = <
  T extends {
    updatedAt: Date
  },
>({
  convertToUtc = false,
  dateFormat = DATE_FORMAT.DEFAULT,
  row: {
    original: { updatedAt },
  },
}: LastModifiedCellProps<T>): JSX.Element => <>{formatDate(updatedAt, dateFormat, convertToUtc)}</>

export default LastModifiedCell
